
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Roundtripcabpune() {



    const cardData =
    {
        keyword: 'Round Trip Cab Pune',
        heading: 'Platinum24 Cabs: Round Trip Cab Pune',
        headingDescription: ' Platinum24 Cabs offers convenient Round Trip Cab Pune services, perfect for family tours, business travel, and weekend getaways. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a comfortable and safe journey with spacious seating and air-conditioned rides. With professional chauffeurs, punctual pickups, and flexible travel schedules, we make your round-trip travel completely hassle-free. Whether you’re heading to Mumbai, Mahabaleshwar, Shirdi, Goa, or any other destination, Platinum24 Cabs provides affordable fares, transparent pricing, and reliable service for all your round-trip cab requirements from Pune.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. Once the seat of the Maratha Empire, it showcases grand gateways, fountains, and gardens. Though partially destroyed by fire in 1828, its ruins still narrate tales of Bajirao and Mastani. The evening light-and-sound show recreates Maratha history. Tourists love exploring its majestic corridors and courtyards. Shaniwar Wada is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, built in 1892, is a majestic monument with Italian arches and sprawling gardens. It is historically significant as Mahatma Gandhi, Kasturba Gandhi, and other leaders were imprisoned here during the Quit India Movement. The palace houses a museum displaying Gandhi’s personal items and photographs. Its calm ambiance attracts history and peace seekers. The palace is also a memorial to Kasturba Gandhi. Aga Khan Palace is Pune’s historic gem of inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is renowned for the 1670 battle where Tanaji Malusare fought for Chhatrapati Shivaji Maharaj. The fort sits atop a hill, offering trekking trails and panoramic views of the Sahyadris. Visitors explore bastions, temples, and memorials that echo Maratha valor. Monsoon adds mist and waterfalls, enhancing its beauty. Local villagers serve rustic delicacies like pithla-bhakri at the top. Sinhagad is Pune’s perfect blend of history and adventure."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most famous shrine dedicated to Lord Ganesha. The magnificent idol is adorned with gold and ornaments, attracting devotees year-round. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. It is also known for charitable and cultural initiatives. The vibrant spiritual aura makes it a must-visit. Dagdusheth Temple is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "The Pataleshwar Cave Temple, carved in the 8th century, is dedicated to Lord Shiva. It features rock-cut architecture with massive stone pillars, a sanctum, and a Nandi mandapa. Located in the city center, it offers a peaceful retreat from urban life. Evening prayers and chants create a mystical ambiance. Its ancient carvings reflect early Indian craftsmanship. Pataleshwar is Pune’s hidden spiritual heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a cultural treasure showcasing over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include ornaments, musical instruments, sculptures, and daily-use antiques. The recreated Mastani Mahal is the highlight for visitors. History lovers and students find it fascinating and educational. The museum preserves centuries of Indian culture and traditions. It is Pune’s proud showcase of heritage and art."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers a panoramic view of the city. At the hilltop stands the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the temple, making it a mix of devotion and adventure. The site also houses smaller shrines and a museum. Sunrise and sunset views are mesmerizing from here. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global hub for spirituality and wellness. Spread across lush gardens, it attracts seekers from around the world. The ashram offers meditation, yoga, and personal growth workshops. Japanese Zen gardens and peaceful meditation halls add to its charm. Visitors experience rejuvenation and mindfulness here. Osho Ashram is Pune’s international wellness destination."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and lush green lawns. Families enjoy peaceful walks, photography, and picnics here. The garden symbolizes Indo-Japanese cultural friendship. Seasonal flowers and manicured spaces attract nature lovers. Pu La Deshpande Garden is Pune’s green oasis of calm and beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend destination near Pune. It supplies water to the city while offering scenic views of hills and flowing waters. Monsoon transforms it into a picturesque spot with overflowing streams. Street vendors selling hot corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],



     "services": [
    {
      "name": "Round Trip Cab Service Pune",
      "description": "Discover seamless and convenient travel with our Round Trip Cab Service in Pune. Whether you need transportation for a corporate event, airport transfers, sightseeing tours, or personal travel, our round trip cabs offer reliability, comfort, and punctuality. Enjoy professional drivers, well-maintained vehicles, and affordable pricing for all your round trip needs within and beyond Pune."
    },
    {
      "name": "Pune Round Trip Taxi",
      "description": "Our Pune Round Trip Taxi service provides a hassle-free way to book cabs for both pickup and drop-off at a single flat rate. Ideal for business travelers and families alike, this service ensures timely pickups, comfortable journeys, and dedicated drivers who prioritize your satisfaction."
    },
    {
      "name": "Round Trip Car Rental Pune",
      "description": "Looking for a round trip car rental in Pune? Choose from a wide variety of vehicles including sedans, SUVs, and luxury cars. Our round trip rentals come with professional chauffeurs or self-drive options, making your travel safe, flexible, and affordable."
    },
    {
      "name": "Affordable Round Trip Cabs Pune",
      "description": "We offer affordable round trip cab services in Pune without compromising on quality. Enjoy transparent pricing, no hidden charges, and value-for-money packages tailored to suit your travel itinerary."
    },
    {
      "name": "Pune Round Trip Taxi Booking",
      "description": "Book your round trip taxi in Pune with ease through our online platform or by phone. Instant booking confirmation, flexible payment options, and 24/7 customer support ensure a seamless experience from start to finish."
    },
    {
      "name": "Pune Round Trip Cab with Driver",
      "description": "Hire a professional driver with your round trip cab rental in Pune to enjoy stress-free travel. Our experienced chauffeurs ensure safe, punctual, and courteous service throughout your journey."
    },
    {
      "name": "Round Trip Taxi for Corporate Pune",
      "description": "Our round trip taxi services cater to corporate clients in Pune, providing timely pickups, comfortable rides, and professional drivers. Perfect for business meetings, airport transfers, conferences, and corporate events."
    },
    {
      "name": "Pune Round Trip Outstation Taxi",
      "description": "Plan your outstation trips with our round trip taxi service from Pune. Travel comfortably to nearby cities and return conveniently with our reliable and affordable outstation round trip taxi options."
    },
    {
      "name": "Round Trip Taxi Packages Pune",
      "description": "Explore our customized round trip taxi packages in Pune, designed to meet different travel needs. Whether for airport transfers, city tours, or corporate travel, our packages are cost-effective and flexible."
    },
    {
      "name": "Pune Round Trip Airport Taxi",
      "description": "Catch your flights on time with our round trip airport taxi service in Pune. We provide prompt pickups and drop-offs, assistance with luggage, and comfortable rides to and from Pune Airport and other major airports."
    },
    {
      "name": "Pune Round Trip Cab Deals",
      "description": "Avail exclusive deals and discounts on round trip cabs in Pune. Book now to enjoy special offers, seasonal discounts, and loyalty benefits on your round trip taxi bookings."
    },
    {
      "name": "Pune Round Trip Cab for Sightseeing",
      "description": "Discover Pune’s top attractions with our round trip sightseeing cab service. Enjoy guided tours with flexible itineraries, comfortable vehicles, and knowledgeable drivers who can make your sightseeing experience memorable."
    },
    {
      "name": "Pune Round Trip Taxi Fare",
      "description": "Get transparent and competitive round trip taxi fares in Pune. We provide upfront pricing based on distance, vehicle type, and trip duration, ensuring no surprises or hidden costs."
    },
    {
      "name": "Round Trip Taxi Booking Online Pune",
      "description": "Book your round trip taxi in Pune conveniently online. Our user-friendly platform allows you to select your vehicle, schedule, and pay securely with instant booking confirmation."
    },
    {
      "name": "Round Trip Taxi Service Pune",
      "description": "Experience premium round trip taxi services in Pune with reliable vehicles, trained drivers, and 24/7 availability. Perfect for both local and outstation travel, ensuring your comfort and safety at every mile."
    }
  ],
  "tableData": [
    ["Round Trip Cab Service Pune", "Pune Round Trip Taxi"],
    ["Round Trip Car Rental Pune", "Affordable Round Trip Cabs Pune"],
    ["Pune Round Trip Taxi Booking", "Pune Round Trip Cab with Driver"],
    ["Round Trip Taxi for Corporate Pune", "Pune Round Trip Outstation Taxi"],
    ["Round Trip Taxi Packages Pune", "Pune Round Trip Airport Taxi"],
    ["Pune Round Trip Cab Deals", "Pune Round Trip Cab for Sightseeing"],
    ["Pune Round Trip Taxi Fare", "Round Trip Taxi Booking Online Pune"],
    ["Round Trip Taxi Service Pune", "—"]
  ],


    "whychoose": [
    {
      "WhyChooseheading": "Convenient Round Trip Cab Service from Pune",
      "WhyChoosedescription": "Platinum24 Cabs offers reliable and comfortable round trip taxi services from Pune to any destination and back."
    },
    {
      "WhyChooseheading": "Perfect for Outstation Travel and Weekend Getaways",
      "WhyChoosedescription": "Ideal for family trips, pilgrimages, and business travel with same-day or multi-day return options."
    },
    {
      "WhyChooseheading": "Well-Maintained, Sanitized & Comfortable Vehicles",
      "WhyChoosedescription": "Travel worry-free in clean, air-conditioned cabs that ensure comfort for long journeys."
    },
    {
      "WhyChooseheading": "Experienced and Courteous Drivers",
      "WhyChoosedescription": "Our trained and verified drivers ensure a safe, smooth, and pleasant ride from start to finish."
    },
    {
      "WhyChooseheading": "Flexible Booking Options for Your Schedule",
      "WhyChoosedescription": "Choose your departure and return times with full flexibility based on your travel plans."
    },
    {
      "WhyChooseheading": "Transparent Round Trip Pricing with No Hidden Charges",
      "WhyChoosedescription": "Enjoy upfront rates including fuel, tolls, and driver allowances—no surprises later."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Seamless Bookings",
      "WhyChoosedescription": "Our team is always available to assist with booking changes, route planning, or special requests."
    },
    {
      "WhyChooseheading": "Wide Range of Vehicle Options for All Group Sizes",
      "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, and tempo travellers to match your comfort and group size."
    }
  ]










































    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs offer round trip cab services in Pune?',
        answer: 'Yes, Platinum24 Cabs provides convenient and flexible round trip cab services from Pune to various destinations.',
    },
    {
        question: 'How do I book a round trip cab in Pune with Platinum24 Cabs?',
        answer: 'You can book your round trip cab through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for round trip cabs in Pune?',
        answer: 'We offer a variety of vehicles including sedans, SUVs, tempo travellers, and luxury cars to suit your travel needs.',
    },
    {
        question: 'Are the drivers experienced for round trip journeys from Pune?',
        answer: 'Yes, our drivers are professional, experienced, and familiar with local and outstation routes originating from Pune.',
    },
    {
        question: 'Can I customize the pickup and drop-off timings for round trip cabs?',
        answer: 'Absolutely! We offer flexible scheduling options to accommodate your preferred pickup and drop-off times.',
    },
    {
        question: 'What is included in the fare for round trip cab services from Pune?',
        answer: 'The fare includes vehicle charges, driver allowance, fuel, tolls, and taxes. Additional charges may apply for extra stops or waiting time.',
    },
    {
        question: 'Is advance booking recommended for round trip cabs in Pune?',
        answer: 'Yes, advance booking ensures availability and helps us provide you with the best service experience.',
    },
    {
        question: 'Are safety and hygiene protocols followed during round trip rides?',
        answer: 'All vehicles are regularly sanitized, and our drivers follow strict safety measures for your protection.',
    },
    {
        question: 'Can I book a round trip cab for corporate travel from Pune?',
        answer: 'Yes, we offer customized corporate round trip packages with flexible billing and priority support.',
    },
    {
        question: 'Do you provide round trip cabs for local sightseeing and outstation travel?',
        answer: 'Yes, round trip cabs can be booked for both local sightseeing tours and outstation trips from Pune.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Ajay Kulkarni',
        feedback: 'The round trip cab service from Pune was seamless. The driver was punctual and the vehicle was very comfortable.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Meera Patil',
        feedback: 'Highly satisfied with the round trip cab booking. Flexible timing and professional service throughout.',
        rating: 5,
    },
];

















































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];






const roundTripCabSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Affordable and reliable Round Trip Cab service in Pune, perfect for corporate travel, sightseeing, airport transfers, and outstation trips.",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "telephone": "+91-XXXXXXXXXX",
  "serviceType": [
    "Round Trip Cab Service Pune",
    "Pune Round Trip Taxi",
    "Round Trip Car Rental Pune",
    "Affordable Round Trip Cabs Pune",
    "Pune Round Trip Taxi Booking",
    "Pune Round Trip Cab with Driver",
    "Round Trip Taxi for Corporate Pune",
    "Pune Round Trip Outstation Taxi",
    "Round Trip Taxi Packages Pune",
    "Pune Round Trip Airport Taxi",
    "Pune Round Trip Cab Deals",
    "Pune Round Trip Cab for Sightseeing",
    "Pune Round Trip Taxi Fare",
    "Round Trip Taxi Booking Online Pune",
    "Round Trip Taxi Service Pune"
  ]
};









    return (
        <div>

<Helmet>
  <title>Round Trip Cab Pune | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Affordable and reliable Round Trip Cab service in Pune, perfect for corporate travel, sightseeing, airport transfers, and outstation trips."
  />
  <meta
    name="keywords"
    content="Round Trip Cab Service Pune, Pune Round Trip Taxi, Round Trip Car Rental Pune, Affordable Round Trip Cabs Pune, Pune Round Trip Taxi Booking, Pune Round Trip Cab with Driver, Round Trip Taxi for Corporate Pune, Pune Round Trip Outstation Taxi, Round Trip Taxi Packages Pune, Pune Round Trip Airport Taxi, Pune Round Trip Cab Deals, Pune Round Trip Cab for Sightseeing, Pune Round Trip Taxi Fare, Round Trip Taxi Booking Online Pune, Round Trip Taxi Service Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(roundTripCabSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/47.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Roundtripcabpune;